import { render, staticRenderFns } from "./FrontCover.vue?vue&type=template&id=f8f59bba&"
import script from "./FrontCover.vue?vue&type=script&lang=js&"
export * from "./FrontCover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports